import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { useAuth } from '@/libs/hooks/use-auth'

export const Route = createFileRoute('/_app/settings')({
	beforeLoad: () => {
		if (useAuth.getState().data?.role !== 'admin') throw redirect({ to: '/' })
	},
	component: RouteComponent,
})

function RouteComponent() {
	return <Outlet />
}
